import React, { Component } from 'react';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import {Button} from 'rmwc/Button';
import { Select } from 'rmwc/Select';
import { Radio } from 'rmwc/Radio';
import { Typography } from 'rmwc/Typography';
import * as actions from '../../actions'
import SerializeForm from 'form-serialize';
import * as api from '../../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Checkbox } from 'rmwc/Checkbox';
import StatusMessage from '../../util/StatusMessage';

class CentaMCRegistration extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      data:{
        'first_name': '',
        'last_name': '',
        'email': '',
        'phone': '',
        'gender_id': '',
        'user_name': '',
        'password': '',
        'password_confirmation':'',
        'certification_level_id': '',
        'certification_level_name': '',
        'certification_type_id': '1',
        'test_track_id': '',
        'test_track_name': '',
        'payment_mode_id': '',
        'amount': '0',
        'discount_code': '',
        'percentage': '0',
        'certification_levels': [],
        'test_tracks': [],
        'payment_modes': [],
        'mc_topics': [],
        'mc_topic': [],
        'feeAmount':'',
        'otp':'',
        'countryCode': '91',
        'countryId': '',
        'countryName': '',
        'countries': [],
        'stateId': '',
        'stateName': '',
        'states': [],
        'testCycles': [], 
        'testCycleId': '', 
        'testDates': []
      },

      formErrors:{
        'firstNameError':'',
        'lastNameError':'',
        'emailError': '',
        'phoneNumberError': '',
        'userNameError' :'',
        'passwordError': '',
        'passwordConfirmationError': '',
        'GenderError':'',
        'LevelError':'',
        'trackError':'',
        'topicError':'',
        'paymentModeError':'',
        'userNameUniqueError': '',
        'emailUniqueError': '',
        'phoneUniqueError': '',
        'countryIdError':'',
        'stateIdError':'',
        'testCycleIdError': '',
        'testDatesError': ''
      },

       registrationResult:{
        'certification_participation_id':'',
        'user_id':'',
        'isSuccess': false
      }

    };
    this.handleCertificationLevelChange = this.handleCertificationLevelChange.bind(this)
    this.handleTestTrackChange = this.handleTestTrackChange.bind(this)
    this.handlePaymentModeChange = this.handlePaymentModeChange.bind(this)
    this.handleDiscountCalculation = this.handleDiscountCalculation.bind(this)
    this.handleMcTopicChange = this.handleMcTopicChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.handleOTPConfirmation = this.handleOTPConfirmation.bind(this)
    this.handleOTPConfirmationAndProceed = this.handleOTPConfirmationAndProceed.bind(this)
    this.userNameValidate = this.userNameValidate.bind(this)
    this.emailValidate = this.emailValidate.bind(this)
    this.handleRegisterPay = this.handleRegisterPay.bind(this)
    this.handleRegister = this.handleRegister.bind(this)
    this.processRegistration = this.processRegistration.bind(this)
    this.phoneValidate = this.phoneValidate.bind(this)
    this.handleCountriesChange = this.handleCountriesChange.bind(this)
    this.handleStatesChange = this.handleStatesChange.bind(this)
  }

  componentDidMount() {

    let data = Object.assign({}, this.state.data)
    let address

    /** Note - below section is commented for disabling the form - remove coment for reenabling - start 
    return api.getCertificationLevels('')
      .then((result) => {
        data.certification_levels = result.certification_level
        return api.getTestTracks('','mc')
        }).then((result) =>{
          data.test_tracks = result
          return api.getPaymentModes('')
        }).then((result) =>{
          data.payment_modes = result
          return api.getMcTopics('')
        }).then((result) =>{
          data.mc_topics = result
          return api.getCountries('')            
        }).then((result) => {
            data.countries = result
            return api.getStates('', 0)
        }).then((result) =>{
            data.states = result
            let url = `test_cycle_cert/1`
            return api.getUserResponse('', url)
        }).then((result) =>{
            data.testCycles = result.data
            data.testCycleId = result.data[0].id
            this.setState({data: data})
        })
    */
   /** Note - above section is commented for disabling the form - remove coment for reenabling - end */
  }

  handleCertificationLevelChange(event) {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    let levelChanged = false
    
    if(!event.target.value){
      data.certification_level_id = ''
      data.certification_level_name = ''
      data.amount = 0
      this.setState({data: data})
    }

    else{
      if (data.certification_level_id === event.target.value)
        levelChanged = false
      else
        levelChanged = true
      if(levelChanged){
        data.certification_level_id = event.target.value
        data.certification_level_name = optionElement.getAttribute('data-name')
        data.percentage = "0"
        data.discount_code = ""
        api.getFeeByLevel('', data.certification_level_id, data.certification_type_id)
        .then((result) => {
          let topicLength = data.mc_topic.length
          data.feeAmount = result.amount
          if(data.certification_level_name.startsWith("Level 1") && data.mc_topic.indexOf('5') > -1 ){       
            topicLength = topicLength -1
          }
          if(data.certification_level_name.startsWith("Level 1") && data.mc_topic.indexOf('3') > -1 ){       
            topicLength = topicLength -1
          }
          if(data.test_track_name.startsWith("Primary") && data.mc_topic.indexOf('2') > -1 ){       
            topicLength = topicLength -1 
          }  
          data.amount = result.amount * topicLength           
          this.setState({data: data})
        })
      }
      //this.setState({data: data})
    }
  }

  handleMcTopicChange(event) {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    if (event.target.checked) {
      data.mc_topic.push(event.target.value)
    } else {
      //data.mc_topic.pop(event.target.value)
      data.mc_topic = data.mc_topic.filter(val => val !== event.target.value);
    }
    data.percentage = "0"
    data.discount_code = ""
    //console.log(data.mc_topic)
 
    // topic length calculation -start
    let topicLength = data.mc_topic.length
    if(data.certification_level_name.startsWith("Level 1") && data.mc_topic.indexOf('5') > -1 ){       
      topicLength = topicLength -1 
    }
    if(data.certification_level_name.startsWith("Level 1") && data.mc_topic.indexOf('3') > -1 ){       
      topicLength = topicLength -1
    }  
    if(data.test_track_name.startsWith("Primary") && data.mc_topic.indexOf('2') > -1 ){       
      topicLength = topicLength -1 
    }
    //console.log(topicLength)
    data.amount = data.feeAmount * topicLength

    let url = `/mc_test_dates/${data.mc_topic}/${data.testCycleId}`
      api.getResponse('', url)
      .then((response) => {
         console.log("inside response of topic change api")
         data.testDates = response.data
        this.setState({data: data})  
    })
    
  }


  handleTestTrackChange(event) {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      data.test_track_id = event.target.value
      data.test_track_name = optionElement.getAttribute('data-name')
    }
    else{
      data.test_track_id = ''
      data.test_track_name = '' 
    }
    data.percentage = "0"
    data.discount_code = ""
    
    let topicLength = data.mc_topic.length
    //Todo - change the topic length logic to single method
    if(data.certification_level_name.startsWith("Level 1") && data.mc_topic.indexOf('5') > -1 ){       
      topicLength = topicLength -1 
    }
    if(data.certification_level_name.startsWith("Level 1") && data.mc_topic.indexOf('3') > -1 ){       
      topicLength = topicLength -1
    }  
    if(data.test_track_name.startsWith("Primary") && data.mc_topic.indexOf('2') > -1 ){       
      topicLength = topicLength -1 
    }
    data.amount = data.feeAmount * topicLength
    this.setState({data: data})

  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handlePaymentModeChange(event) {
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    data.payment_mode_id = event.target.value
    data.state_name = optionElement.getAttribute('data-name')
    this.setState({data: data})
  }

  handleDiscountCalculation(event) {
    event.preventDefault();
    //console.log("Done update profile:" + this.state.data.discount_code)
    let data = Object.assign({}, this.state.data)
    api.calculateMCDiscount('', data.certification_level_id, data.certification_type_id, data.discount_code, data.mc_topic.length)
    .then((result) => {
      //console.log(result);
      data.amount = result.amount 
      data.percentage = result.percentage
      this.setState({data: data})
    })

  }

  userNameValidate(){
    if(this.state.data.user_name !== ''){
      let formErrors = Object.assign({}, this.state.formErrors)
      api.validateUserName(this.state.data.user_name)
      .then((result) => {
        console.log(result)
        if(result.status ==='success'){
          formErrors.userNameUniqueError=''
        }
        else{
          formErrors.userNameUniqueError ='User name is already taken up'
        }
        
        this.setState({formErrors: formErrors})

      })
    }
  }

   phoneValidate(){
    if(this.state.data.phone !== ''){
      let formErrors = Object.assign({}, this.state.formErrors)
      api.validatePhone(this.state.data.countryCode+this.state.data.phone)
      .then((result) => {
        console.log(result)
        if(result.status ==='success'){
          formErrors.phoneUniqueError=''
        }
        else{
          formErrors.phoneUniqueError ='Mobile Number is already taken up'
        }
        
        this.setState({formErrors: formErrors})

      })
    }
  }


  emailValidate(){
    if(this.state.data.email !== ''){
      let formErrors = Object.assign({}, this.state.formErrors)
      var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
      if(pattern.test(this.state.data.email)){
        api.validateEmail(this.state.data.email)
        .then((result) => {
          if(result.status ==='success'){
            formErrors.emailUniqueError=''
          }
          else{
            formErrors.emailUniqueError ='Email is already taken up'
          }
          
          this.setState({formErrors: formErrors})
          
        })
      }
    }
  }

  handleCountriesChange(event) {  
    var index = event.target.selectedIndex;
    var optionElement = event.target.childNodes[index]
    let data = Object.assign({}, this.state.data)
    let countryChanged = true
    data.countryId = event.target.value
    data.countryName = optionElement.getAttribute('data-name')

    if (countryChanged) {
      api.getStates('', data.countryId)
      .then((states) => {
        data.states = states
        data.stateId = ''
        this.setState({data: data})
      })
    } else {
      this.setState({data: data})
    }
  }

  handleStatesChange(event){
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      let selectedOption = event.target.value
      data.stateId = selectedOption
    }
    else{
      data.stateId = ''
    }
    this.setState({data: data})
  }


  handleTestCycleChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    console.log(data.mc_topic)
    if(event.target.value){
      let selectedOption = event.target.value
      data.testCycleId = selectedOption
      let url = `/mc_test_dates/${data.mc_topic}/${data.testCycleId}`
       api.getResponse('', url)
      .then((response) => {
        console.log(response)
        data.testDates = response.data
        this.setState({data: data})  
      })
    }
    else{
      data.testCycleId = ''
      this.setState({data: data})
    }
    
  }

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)
    errorObj.firstNameError = ''
    errorObj.lastNameError = ''
    errorObj.LevelError = ''
    errorObj.trackError = ''
    errorObj.paymentModeError = ''
    errorObj.topicError = ''
    errorObj.phoneNumberError =''
    errorObj.userNameError =''
    errorObj.passwordError =''
    errorObj.passwordConfirmationError =''
    errorObj.GenderError =''
    errorObj.emailError =''
    errorObj.countryIdError = ''
    errorObj.testCycleIdError = ''
    errorObj.testDatesError = ''



    if(data.first_name === ''){
      errorObj.firstNameError ='First Name is mandatory'
      error = false
    }

    if(data.last_name === ''){
      errorObj.lastNameError ='Last Name is mandatory'
      error = false
    }

    if(data.email === undefined || data.email === ''){
      errorObj.emailError ='Email is Mandatory'
      error = false
    }

    if(data.countryId === ''){
        errorObj.countryIdError ='Country is mandatory'
        error = false
    }

    if(data.user_name === ''){
      errorObj.userNameError ='User Name is mandatory'
      error = false
    }

    if(data.test_track_id === ''){
      errorObj.trackError ='Track is mandatory'
      error = false
    }

     if(data.certification_level_id === ''){
      errorObj.LevelError ='Level is mandatory'
      error = false
    }

    if(data.payment_mode_id === ''){
      errorObj.paymentModeError = 'Payment is mandatory'
      error = false
    }

     if(data.phone === ''){
      errorObj.phoneNumberError ='Mobile Number is mandatory'
      error = false
    }
    else{
      var phoneno = /^\d{12}$/;
      let fullPhoneNumber = data.countryCode+data.phone
      if(!fullPhoneNumber.match(phoneno)){
        errorObj.phoneNumberError ='Please enter a valid mobile number'
        error = false
      }
    }

    if(data.gender_id === ''){
      errorObj.GenderError ='Gender is mandatory'
      error = false
    }

    if(data.password === ''){
      errorObj.passwordError ='Password is mandatory'
      error = false
    }

    if(data.password_confirmation === ''){
      errorObj.passwordConfirmationError ='Confirm Passowrd is mandatory'
      error = false
    }

    if(data.password !== data.password_confirmation){
      errorObj.passwordError = 'Password and Confirm password are not matching'
      error = false
    }

    if(data.testCycleId === ''){
      errorObj.testCycleIdError ='Test Cycle - Preferred Month is Mandatory'
      error = false
    }

    if(data.testCycleId !== ''){
      if(data.testDates === undefined){
        errorObj.testDatesError ='Test Date is not configured. Please contact Administrator'
       error = false
      }

      if(data.testDates !== undefined && data.testDates.length == 0 ){
        errorObj.testDatesError ='Test Date is not configured. Please contact Admin'
        error = false
      }
    }

    this.setState({
      formErrors:errorObj,
      errorMsg:''
    })
    return error
  }

  handleSubmit(e){
    e.preventDefault()
  }

  handleRegister(e){
    e.preventDefault()
    this.processRegistration(false)
  }

  handleRegisterPay(e){
    e.preventDefault()
    this.processRegistration(true)
  }

  processRegistration = (isPayment) => {

    let data = Object.assign({}, this.state.data)

    if(this.validateForm()){

      let apiInput = {
        'certification_participation': {
          'certification_level_id': data.certification_level_id,
          'certification_type_id': '1'    
        },      
        'micro_credentials_certification': {
          'test_track_id': data.test_track_id,
          'test_cycle_id': data.testCycleId
        },      
        'payment': {
          'payment_mode_id': data.payment_mode_id,
          'discount_code': data.discount_code,
          'currency': 'RS'
        },      
        'micro_credentials_topic': {
          'id': data.mc_topic,
        },
        'user':{
          'email': data.email,
          'phone': data.countryCode+data.phone,
          'password': data.password,
          'password_confirmation': data.password_confirmation,
          'user_name': data.user_name,
          'country_code': data.countryCode
        },
        'personal_info':{
          'first_name': data.first_name,
          'last_name': data.last_name,
          'gender_id': data.gender_id
        },
        'payment_option':{
          'is_payment': isPayment
        },
        'address':{
          'state_id': data.stateId,
          'country_id': data.countryId
        },
      }
      let countryCodeIndia = '91'
      api.saveCentaMicroCredentailCertifications(apiInput)
      .then((result) => {
        //console.log("Done MC:" + JSON.stringify(result))
        if(result.errors){
          this.setState({ errorMsg: result.errors })
        }
        else{
          let registrationResult = Object.assign({}, this.state.registrationResult)
          registrationResult.certification_participation_id = result.certification.id
          registrationResult.user_id = result.user.id

          if(this.state.data.countryCode === countryCodeIndia){
            registrationResult.isSuccess = true
            this.setState({registrationResult: registrationResult})
          }

          else{
            const obj = {}
             
            obj.accessToken = result.headers.accessToken
            obj.userName = result.user.userName
            obj.id = result.user.id
            obj.role = result.role
            this.props.userLogin(obj)
            if(result.redirectTo)
              window.top.location.href = result.redirectTo;
            else{
              window.top.location.href = "/portal/app/my_registrations";        
            }
          }
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })
    }
  }

  handleOTPConfirmationAndProceed(e){
    e.preventDefault();
    this.processOTPConfirmation(true)
  }

  handleOTPConfirmation(e){
    e.preventDefault();
    this.processOTPConfirmation(false)
  }

  processOTPConfirmation = (isPayment) => {
    let apiInput = {
        'certification_participation_id': this.state.registrationResult.certification_participation_id,
        'confirmation_otp': this.state.data.otp,
        'payment_option':{
          'is_payment': isPayment
        }
      }  
      this.setState({ errorMsg: '' })
      api.confirmOTPRegistration(apiInput)
      .then((result) => {

        if(result.errors){
          this.setState({ errorMsg: result.errors })
        }
        else{
           const obj = {}
           let data
           obj.accessToken = result.headers.accessToken
           data = result.data
           obj.userName = data.user.userName
           obj.role = data.role
           obj.id = data.user.id
           this.props.userLogin(obj)
           if(result.redirectTo)
            window.top.location.href = result.redirectTo;
          else{
            window.top.location.href = "/portal/app/my_registrations";          
          }
        }
        })
        .catch((err) => {
          this.setState({ errorMsg: err.stack })
      })
  }

  render() {
    let countryCodeIndia = '91'
    let handleMcTopicChange = this.handleMcTopicChange
    let certification_level_name = this.state.data.certification_level_name
    let test_track = this.state.data.test_track_name
    let mc_topic = this.state.data.mc_topic
    let renderCheckbox
    if(this.state.data.certification_level_id ===''){

      renderCheckbox = (<div className="topic-width">
                  <label>Select one or more Micro-Credentials:</label>
                  <br/>
                  {this.state.data.mc_topics.map(function(level) {
                     
                      return (
                        <Checkbox key={level.id} value={level.id} disabled name="mc_topic[]"
                      onChange={handleMcTopicChange}>
                      {level.name}
                      </Checkbox>
                      )
                    }
                    
                  )}
                </div>)
    }
    else{
      renderCheckbox = <div className="topic-width">
                    <label>Select one or more Micro Credentials:</label>
                    <br/>
                    {this.state.data.mc_topics.map(function(level) {
                      if((level.id === 5 && certification_level_name.startsWith("Level 1")) || 
                        (level.id === 2 && test_track.startsWith("Primary")) ||
                        (level.id === 3 && certification_level_name.startsWith("Level 1"))){
                        return (
                          <Checkbox key={level.id} value={level.id} disabled name="mc_topic[]"
                        onChange={handleMcTopicChange}>
                        {level.name}
                        </Checkbox>
                        )
                      }
                      return (<Checkbox key={level.id} value={level.id}  name="mc_topic[]"
                        onChange={handleMcTopicChange}>
                        {level.name}
                      </Checkbox> )
                    })}
                  </div>
     }

    let renderTrackComp
    
    if(this.state.data.certification_level_id ===''){
      
      renderTrackComp = <div>
                    <Select
                      name="test_track"
                      onChange={this.handleTestTrackChange}
                      value={this.state.data.test_track_id}
                      className="select-component"
                      placeholder="-- Select Test Track --"
                    >
                      {this.state.data.test_tracks.map(level => (
                        <option disabled key={level.id} value={level.id} data-name={level.name}>
                          {level.name}
                        </option>
                      ))}
                    </Select>
                </div>
    }
    else{
      
      renderTrackComp = <div>
                    <Select
                      name="test_track"
                      onChange={this.handleTestTrackChange}
                      value={this.state.data.test_track_id}
                      className="select-component"
                      placeholder="-- Select Test Track --"
                    >
                      {this.state.data.test_tracks.map(level => (
                        <option key={level.id} value={level.id} data-name={level.name}>
                          {level.name}
                        </option>
                      ))}
                    </Select>
                </div>
    }  

    let registerButton
    let registerPayButton
    if (this.state.data.amount > 0)
      registerButton = (<Button raised onClick={this.handleRegister}>Register</Button>)
    else
      registerButton = <Button raised disabled>Register</Button>

    let otpTextbox
    let otpConfirmationButton
    let otpConfirmationButtonProceed

    if(!this.state.registrationResult.isSuccess){
      if (this.state.data.amount > 0){
        registerButton = (<Button raised onClick={this.handleRegister}>Register</Button>)
        if(this.state.data.countryCode !== countryCodeIndia)
          registerPayButton = (<Button raised onClick={this.handleRegisterPay}>Register & Pay</Button>)
      }
      else
        registerButton = (<Button raised disabled>Register</Button>)
      }
    else{
      otpTextbox= <TextField fullwidth className='text_input' label="Enter OTP (One time password sent to your mobile number)" autoComplete="off"  name="otp" onChange={this.onInputChange} value={this.state.data.otp}/>
      otpConfirmationButton = <Button raised onClick={this.handleOTPConfirmation} theme="secondary-bg on-secondary">Confirm</Button>
      if(this.state.data.payment_mode_id === '1'){
       otpConfirmationButtonProceed = <Button raised onClick={this.handleOTPConfirmationAndProceed} theme="secondary-bg on-secondary" className="confirm-proceed-button">Confirm & Pay</Button>
      }
      registerButton = (<Button raised disabled>Register</Button>)
    }

    let checqueMsgDisplay
    if(this.state.data.payment_mode_id === '2'){
    checqueMsgDisplay = (<div>
        <p>The demand draft/cheque should be drafted in the favour of Centre for Teacher Accreditation (CENTA) Pvt. Ltd. and couriered to the following address:</p>
        <p>Centre for Teacher Accreditation,</p> 
        <p>#22, 3rd Floor, HAL 3rd Stage,</p> 
        <p>80 Ft. Road, Indiranagar,</p> 
        <p>Bengaluru, Karnataka 560075</p>
        <p>+91 7349662401</p>
        </div>)    
    }

    let discountDetail

    if(this.state.data.percentage > 0){
      discountDetail= (
            <div>
              <label>Registration Fee:</label>
              <span className="amount-input">{this.state.data.amount} ({this.state.data.percentage}% Discount) (including GST)</span>
            </div>
        )
    }
    else{
       discountDetail= (
            <div>
              <label>Registration Fee:</label>
              <span className="amount-input">{this.state.data.amount} (including GST)</span>
            </div>
        )
    }

    let renderallTpoicSelMsgComponent
    if(mc_topic.length == 5){
      renderallTpoicSelMsgComponent =(
          <div>
            <p> In case you are planning to register for all 5 Micro-Credentials”, we would request you to register through the CENTA Certification Registration form to register at a discounted registration fee</p>
          </div>
        )
    }

    let selCountryId = this.state.data.countryId
    
    let paymentModeComponent =(
                  <div>
                    <Select
                      name="payment_mode"
                      onChange={this.handlePaymentModeChange}
                      value={this.state.data.payment_mode_id}
                      className="select-component"
                      placeholder="--Select Payment Mode--"
                    >
          {this.state.data.payment_modes.map(function(level){
            if(selCountryId){
              if((level.id === 2))
                return (<option key={level.id} value={level.id} data-name={level.name}>
                  {level.name}
                  </option>)

              if(((level.id === 4 || level.id === 5 || level.id === 6 || level.id === 7) && selCountryId === '1'))
                return (<option key={level.id} value={level.id} data-name={level.name}>
                  {level.name}
                  </option>)

              if((level.id === 3 && selCountryId !== '1'))
                return (<option key={level.id} value={level.id} data-name={level.name}>
                  {level.name}
                  </option>)              
              
              }
            
                      })}
            </Select> </div>
      )

     let testDateComponent 
      let count = 1
      if(this.state.data.testDates !== undefined &&  this.state.data.testDates.length !=0){
        testDateComponent =(<div> <br/><Typography use="caption"> <b>Test Dates: </b></Typography><br/>
                {this.state.data.testDates.map(function(testDate) {
                 
                 return <div><Typography use="caption"> {count++}) {testDate.name} on {testDate.date} at {testDate.time}</Typography></div>
                })}
                         
        </div>
        )
      }

    let mainFormComponent
    mainFormComponent = (
      <div><br/><Typography use="subtitle">Registrations for CENTA Certification are currently closed. We will opening the registrations for the January cycle in the coming weeks</Typography><br/><br/></div>
    )
    /** MC Component Disabled. To reenable remove the commented section below and chane the message above */
   /** mainFormComponent =(
      <div>
              <form onSubmit={this.handleSubmit}>
                <TextField label="First Name" autoComplete="off" name="first_name" onChange={this.onInputChange} value={this.state.data.first_name}/>
                <TextField label="Last Name" autoComplete="off"  name="last_name" onChange={this.onInputChange} value={this.state.data.last_name}/>
                <TextField label="Email" autoComplete="off"  name="email" onChange={this.onInputChange} value={this.state.data.email} onBlur={this.emailValidate}/>
                <StatusMessage error_msg = {this.state.formErrors.emailUniqueError}/>
                <div>
                  Gender:
                  <Radio 
                    name="gender_id"
                    value="1"
                    checked={this.state.data.gender_id == '1'}
                    onChange={this.onInputChange}>
                    Male
                  </Radio>
                  <Radio
                    name="gender_id"
                    value="2"
                    checked={this.state.data.gender_id == '2'}
                    onChange={this.onInputChange}>
                    Female
                  </Radio>
                  <Radio
                    name="gender_id"
                    value="3"
                    checked={this.state.data.gender_id == '3'}
                    onChange={this.onInputChange}>
                    Other
                  </Radio>
                </div>
                <TextField label="User Name" autoComplete="off"  name="user_name" onChange={this.onInputChange} value={this.state.data.user_name} onBlur={this.userNameValidate}/>
                <StatusMessage error_msg = {this.state.formErrors.userNameUniqueError}/>
                <div>
                <TextField  className="country-code" label="Code" autoComplete="off"  name="countryCode" onChange={this.onInputChange} value={this.state.data.countryCode}/>
                &nbsp;
                <TextField  label="Mobile No." autoComplete="off"  name="phone" onChange={this.onInputChange} value={this.state.data.phone} onBlur={this.phoneValidate}/>
                <StatusMessage error_msg = {this.state.formErrors.phoneUniqueError}/>
                </div>
                <TextField  type="password" label="Password" autoComplete="off"  name="password" onChange={this.onInputChange} value={this.state.data.password}/>
                <TextField  type="password" label="Confirm Password" autoComplete="off"  name="password_confirmation" onChange={this.onInputChange} value={this.state.data.password_confirmation}/>
                
                <br/>
                <div className="full-width">
                    
                    <div className="mdc-select" role="listbox">
                      <select 
                        name="country"
                        onChange={this.handleCountriesChange}
                        value={this.state.data.countryId}
                        className="mdc-select__native-control two-col-input"
                      >
                        <option value="" selected="">--Select Country--</option>
                        {this.state.data.countries.map(country => (
                          <option key={country.id} value={country.id} data-name={country.name}>
                            {country.name}
                          </option>
                        ))}
                      </select>
                      <label className="mdc-floating-label mdc-floating-label--float-above">Country</label>
                      <div className="mdc-line-ripple"></div>
                    </div>

                      {this.state.data.states.length !=0 &&
                      <Select
                        name="state"
                        onChange={this.handleStatesChange}
                        value={this.state.data.stateId}
                        className="two-col-input tpo-reg-form-second-col"
                        placeholder='-- Select State of residence --'
                      >
                        {this.state.data.states.map(state => (
                          <option key={state.id} value={state.id} data-name={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </Select>
                     }
                </div>
                <br/>


                <div>
                  <Select
                    name="certification_level"
                    onChange={this.handleCertificationLevelChange}
                    value={this.state.data.certification_level_id}
                    className="select-component"
                    placeholder="-- Select Level --"
                  >
                    {this.state.data.certification_levels.map(level => (
                      <option key={level.id} value={level.id} data-name={level.name}>
                        {level.name}
                      </option>
                    ))}
                  </Select>
                </div>
                <br/>
                
                {renderTrackComp}
                <br/>
                <div className="topic-width">
                  {renderCheckbox}
                </div>
                 <div>
                  <Select
                    name="test_cycle"
                    onChange ={this.handleTestCycleChange}
                    value={this.state.data.testCycleId}
                    className="select-component"
                    placeholder="-- Select Cycle --"
                  >
                    {this.state.data.testCycles.map(cycle => (
                      <option key={cycle.id} value={cycle.id} data-name={cycle.name}>
                        {cycle.name}
                      </option>
                    ))}
                  </Select>
                </div>
                {testDateComponent}
                  {renderallTpoicSelMsgComponent}                
                <div>
                  <TextField className="discount-input" label="Enter referral code (if any)" autoComplete="off"  name="discount_code" onChange={this.onInputChange} value={this.state.data.discount_code}/>
                  <Button outlined onClick={this.handleDiscountCalculation}>Apply</Button>
                </div>
                <br/>
                {discountDetail}
                <br/>
                {paymentModeComponent}
                <br/>
                {checqueMsgDisplay}
                
                <div>  
                {registerButton}
                &nbsp;{registerPayButton}
                </div>
                {otpTextbox}
                <div>
                {otpConfirmationButton}
                {otpConfirmationButtonProceed}
                </div>
              </form> 
            </div>
    )
    */

    /** MC Main component disbaled. remove comment to endble - end */

    return (
      <div class="mdc-layout-grid">
        <div class="mdc-layout-grid__inner"> 
          <div class="mdc-layout-grid__cell--span-10 reg-form-background reg-form-padding">
            <br/>
            <Typography use="headline5">CENTA Micro-Credentials Registration</Typography>
              <br/>
              <br/>
              {mainFormComponent}
              <StatusMessage error_msg = {this.state.errorMsg}/>
              <StatusMessage error_msg = {this.state.formErrors.firstNameError}/>
              <StatusMessage error_msg = {this.state.formErrors.lastNameError}/>
              <StatusMessage error_msg = {this.state.formErrors.emailError}/>
              <StatusMessage error_msg = {this.state.formErrors.countryIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.userNameError}/>
              <StatusMessage error_msg = {this.state.formErrors.phoneNumberError}/>
              <StatusMessage error_msg = {this.state.formErrors.GenderError}/>
              <StatusMessage error_msg = {this.state.formErrors.passwordError}/>
              <StatusMessage error_msg = {this.state.formErrors.passwordConfirmationError}/>
              <StatusMessage error_msg = {this.state.formErrors.LevelError}/>
              <StatusMessage error_msg = {this.state.formErrors.trackError}/>
              <StatusMessage error_msg = {this.state.formErrors.paymentModeError}/>
              <StatusMessage error_msg = {this.state.formErrors.testCycleIdError}/>
              <StatusMessage error_msg = {this.state.formErrors.testDatesError}/>

          </div>
          <div class="mdc-layout-grid__cell--span-1"></div>
          <div class="mdc-layout-grid__cell--span-1"></div>
        </div>
      </div>
    )
  }
}

function mapStateToProps() {
  
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CentaMCRegistration);



// WEBPACK FOOTER //
// ./src/views/centa/CentaMCRegistration.jsx